import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useSelector} from "react-redux";
import {isLoading, getBlockingMessage} from "../app/store.js";

import "./loading_indicator.scss";

export function LoadingSpinner({className, message}) {
  const combinedClassName = classnames("loading-spinner", className);

  return (
    <div className={combinedClassName}>
      <div className="loading-spinner__indicator" />
      {message && <div>{message}</div>}
    </div>
  );
}

LoadingSpinner.propTypes = {
  className: PropTypes.string,
  message: PropTypes.node
};

export function InlineLoadingIndicator({children, message, typePrefix, className}) {
  const combinedClassName = classnames("loading-indicator", className);
  const loading = useSelector((state) => isLoading(state, {typePrefix}));

  return loading
    ? <LoadingSpinner className={combinedClassName} message={message} />
    : <>{children}</>;
}

InlineLoadingIndicator.propTypes = {
  children: PropTypes.node,
  message: LoadingSpinner.propTypes.message,
  typePrefix: PropTypes.string,
  typePrefixes: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool
};

export function FullScreenLoadingIndicator({blockingActions}) {
  const message = useSelector((state) => getBlockingMessage(state, {blockingActions}));

  if (!message) {
    return null;
  }

  return (
    <div className="full-screen-loading-indicator">
      <LoadingSpinner className="full-screen-loading-indicator__indicator" message={message} />
    </div>
  );
}